export const getLocation = (location) => {
  return {
    type: 'LOCATION',
    payload: location,
  }
}